var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 9.50098C18.9555 9.50098 10.0005 18.456 10.0005 29.501C10.0005 40.546 18.9555 49.501 30.0005 49.501C41.0455 49.501 50.0005 40.546 50.0005 29.501C50.0005 18.456 41.0455 9.50098 30.0005 9.50098Z",
    fill: "url(#paint0_linear_184103_183558)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0005 32C84.173 32 83.358 32.045 82.5505 32.1225C76.853 24.475 67.7705 19.5 57.5005 19.5C43.218 19.5 31.2005 29.0925 27.4705 42.1775C17.623 43.4225 10.0005 51.8125 10.0005 62C10.0005 73.045 18.9555 82 30.0005 82C34.5455 82 80.268 82 85.0005 82C98.808 82 110 70.8075 110 57C110 43.1925 98.808 32 85.0005 32Z",
    fill: "url(#paint1_linear_184103_183558)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5349 103.036C76.5824 104.988 73.4174 104.988 71.4649 103.036C69.5124 101.083 69.5124 97.9185 71.4649 95.966C73.4174 94.0135 82.4999 92.001 82.4999 92.001C82.4999 92.001 80.4874 101.083 78.5349 103.036Z",
    fill: "url(#paint2_linear_184103_183558)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0353 98.035C34.0828 99.9875 30.9179 99.9875 28.9654 98.035C27.0129 96.0825 27.0129 92.9175 28.9654 90.965C30.9179 89.0125 40.0004 87 40.0004 87C40.0004 87 37.9878 96.0825 36.0353 98.035Z",
    fill: "url(#paint3_linear_184103_183558)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5344 113.035C51.5819 114.988 48.4169 114.988 46.4644 113.035C44.5119 111.083 44.5119 107.917 46.4644 105.965C48.4169 104.012 57.4994 102 57.4994 102C57.4994 102 55.4869 111.083 53.5344 113.035Z",
    fill: "url(#paint4_linear_184103_183558)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184103_183558",
    x1: 11.2855,
    y1: 10.786,
    x2: 44.113,
    y2: 43.6135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184103_183558",
    x1: 53.283,
    y1: 19.6975,
    x2: 64.0455,
    y2: 83.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.482325,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_184103_183558",
    x1: 82.9995,
    y1: 92.001,
    x2: 76.2502,
    y2: 104.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_184103_183558",
    x1: 40.5,
    y1: 87,
    x2: 33.7507,
    y2: 99.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_184103_183558",
    x1: 57.999,
    y1: 102,
    x2: 51.2497,
    y2: 114.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095E9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.edb770d4b312d7a479fdc88645acd7b7.svg";
export { ForwardRef as ReactComponent };